import { useEffect, useRef, useState } from 'react'

export function useDetectAdBlock() {
  const [isDetected, setIsDetected] = useState<boolean>(false)

  useEffect(() => {
    // fetch https://eu.i.posthog.com to test if adblock is enabled
    // if it returns 404, adblock is disabled
    const testAdBlock = async () => {
      try {
        const response = await fetch('https://eu.i.posthog.com/', {
          method: 'GET',
          mode: 'no-cors',
        })
        if (!response) {
          setIsDetected(true)
        } else {
          setIsDetected(false)
        }
      } catch (err) {
        setIsDetected(true)
      }
    }
    testAdBlock()
  }, [])

  return isDetected
}

export function useTrueToFalse(value: boolean): boolean {
  const prev = useRef<boolean | null>(null)
  const [triggered, setTriggered] = useState(false)

  useEffect(() => {
    if (prev.current === true && value === false) {
      setTriggered(true)
    } else {
      setTriggered(false)
    }

    prev.current = value
  }, [value])

  return triggered
}
